'use strict';

require('picturefill')();
require('dragscroll');
require('@fancyapps/fancybox');

require('./bootstraps/common').init();
require('./bootstraps/widgets').init();
